import React from "react";
import Moment from "moment";
import { Table, Button } from "reactstrap";

const TableLogs = (props) => {
    const styles = {
        tableHead: {
            paddingTop: "4vh",
            fontSize: "1em",
            textTransform: "capitalize",
            color: "#2c2a2a",
        },
    };

    const displayMoney = (amount) => {
        return new Intl.NumberFormat("en-SG", {
            style: "currency",
            currency: "SGD",
            minimumFractionDigits: 2,
        }).format(amount);
    };

    const displayDate = (date) => {
        return Moment(date).format("DD MMMM YYYY");
    };

    const getGtoDate = (eventLog) => {
        if (eventLog.gto_date) return eventLog.gto_date;

        // Existing logs created before gto_date existed were generated for the
        // previous day's GTO submission in the scheduled flow.
        return Moment(eventLog.created_at).subtract(1, "day");
    };

    return (
        <Table className="align-items-center" hover responsive>
            <thead>
                <tr>
                    {props.header?.map((item, index) => (
                        <th style={styles.tableHead} key={index}>
                            {item}
                        </th>
                    ))}
                </tr>
            </thead>

            <tbody>
                {props.searchedData?.map((eventLog, index) => (
                    <tr key={index}>
                        <td style={{ color: "#6c6c6c" }}>
                            {eventLog.Shop.location}
                        </td>
                        <td style={{ color: "#6c6c6c" }}>
                            {Moment(eventLog.created_at).format(
                                "DD MMMM YYYY, h:mm a"
                            )}
                        </td>
                        <td
                            style={
                                eventLog.is_uploaded === true
                                    ? { color: "#12d67b", fontWeight: "bold" }
                                    : { color: "#cc0000", fontWeight: "bold" }
                            }
                        >
                            {eventLog.is_uploaded === true ? " YES" : "NO"}
                        </td>
                        <td style={{ color: "#6c6c6c" }}>
                            {getGtoDate(eventLog)
                                ? displayDate(getGtoDate(eventLog))
                                : "Unavailable"}
                        </td>
                        <td style={{ color: "#6c6c6c" }}>
                            {eventLog.total_sum
                                ? displayMoney(eventLog.total_sum)
                                : "Unavailable"}
                        </td>
                        <td style={{ color: "#6c6c6c" }}>
                            <Button
                                color="secondary"
                                outline
                                type="button"
                                onClick={() => {
                                    props.downloadFile(
                                        eventLog.file_name,
                                        eventLog.file_content
                                    );
                                }}
                            >
                                {eventLog.file_name && "DOWNLOAD"}
                            </Button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

export default TableLogs;
